
// ABOUTME: HR dashboard page with URL routing and role filtering support
// ABOUTME: Handles role-specific filtering via URL parameters

import React from 'react';
import HRDashboard from '@/components/hr/HRDashboard';
import { useNavigate, useParams } from 'react-router-dom';
import { useJobRoles } from '@/hooks/useJobRoles';

const HRDashboardPage = () => {
  const navigate = useNavigate();
  const { roleId } = useParams();
  const { jobRoles } = useJobRoles();

  // Find the role if roleId is provided
  const selectedRole = roleId ? jobRoles?.find(role => role.id === roleId) : null;

  const handleViewChange = (view: string, filters?: { jobRoleId?: string; jobRoleTitle?: string }) => {
    switch (view) {
      case 'dashboard':
        navigate('/');
        break;
      case 'submit':
        navigate('/role-hub');
        break;
      case 'public-profile':
        navigate('/my-profile');
        break;
      case 'hr-dashboard':
        if (filters?.jobRoleId) {
          navigate(`/hr/roles/${filters.jobRoleId}`);
        } else {
          navigate('/hr');
        }
        break;
      case 'manage-roles':
        navigate('/manage-roles');
        break;
      case 'billing':
        navigate('/billing');
        break;
      case 'security-audit':
        navigate('/security-audit');
        break;
      default:
        navigate('/hr');
    }
  };

  // Prepare filters for the dashboard
  const filters = selectedRole ? {
    jobRoleId: selectedRole.id,
    jobRoleTitle: selectedRole.title
  } : undefined;

  return <HRDashboard onViewChange={handleViewChange} filters={filters} />;
};

export default HRDashboardPage;
